import type { ReactNode } from "react";
import { SimpleHeader } from "@/components/headers/simple-header";
import { FullFooter } from "@/components/footers/full-footer";
import { FooterParticleWordmark } from "@/components/footer-particle-wordmark";

// (legal): SimpleHeader + FullFooter — low-distraction (§6.1)
export default function LegalLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col">
      <SimpleHeader />
      <main id="main" tabIndex={-1} className="flex-1">
        {children}
      </main>
      <FullFooter />
      <FooterParticleWordmark />
    </div>
  );
}
